import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import CustomFlexLayout from '../../components/flexLayout';
import DownloadButton from '../../components/PDFReader/downloadButton';
import SingleSlideSwiper from '../../components/carrousel/singleSideSwiper';

import { translations } from '../../constants';

import { carouselBelieveImages } from '../../constants/dummydata';
import PATHS from '../../routes/paths';

import '../../assets/scss/index.scss';

const WhatWeBelieve = () => {
  const [activeCollapseKey, setActiveCollapseKey] = useState(['1']);
  const navigate = useNavigate();

  const { en } = translations;

  const { whatWeBelieve } = en.whatWeBelieve;

  const { introParagraphs, newSentences } = en.whatWeBelieve.faithOfAmendment;

  const updatedIntroParagraphs = [
    ...introParagraphs,
    ...newSentences.map((sentence, index) => `${index + 1}. ${sentence}`)
  ];

  const getCarousel = () => (
    <div className='carousel-container radius-10'>
      <SingleSlideSwiper
        data={carouselBelieveImages}
        clickable={true}
        navigation={false}
        className='mySwiper img-carousel-slide'
      />
    </div>
  );
  const beliefItemsData = [
    {
      key: '1',
      id: 'whatWeBelieveAndPreach',
      heading: en.whatWeBelieve.whatWeBelieveAndPreach.heading,
      title: en.whatWeBelieve.whatWeBelieveAndPreach.title,
      content:
        '',
      paragraphs: en.whatWeBelieve.whatWeBelieveAndPreach.introParagraphs,
      isWhatWeBelieve: true,
    },
    {
      key: '2',
      id: 'statementOfFaith',
      heading: en.whatWeBelieve.faithOfAmendment.heading,
      title: en.whatWeBelieve.faithOfAmendment.title,
      content:
        'This document provides the foundational truths to be received by the Christadelphians. It emphasizes the inerrancy of the Scriptures and their divine inspiration.',
      paragraphs: updatedIntroParagraphs,
      isFaithOfAmendment: true
    },
    {
      key: '3',
      id: 'commandmentsOfChrist',
      heading: en.whatWeBelieve.Epitome.heading,
      title: en.whatWeBelieve.Epitome.title,
      content:
        'This document contains an epitome of the commandments of Christ, guiding believers on how to live a life of faith and obedience.',
      paragraphs: en.whatWeBelieve.Epitome.introParagraphs
    },
    {
      key: '4',
      id: 'doctrinesToBeRejected',
      heading: en.whatWeBelieve.rejectedDoctrines.heading,
      title: en.whatWeBelieve.rejectedDoctrines.title,
      content:
        'This document lists doctrines that the Christadelphians reject as unbiblical, such as the trinity and the immortal soul.',
      paragraphs: en.whatWeBelieve.rejectedDoctrines.introParagraphs
    }
  ];

  const sectionMap = {
    1: 'whatWeBelieveAndPreach-title',
    2: 'statementOfFaith-title',
    3: 'commandmentsOfChrist-title',
    4: 'doctrinesToBeRejected-title',
    whatWeBelieveAndPreach: 'whatWeBelieveAndPreach-title',
    statementOfFaith: 'statementOfFaith-title',
    commandmentsOfChrist: 'commandmentsOfChrist-title',
    doctrinesToBeRejected: 'doctrinesToBeRejected-title'
  };

  const phrases = [
    { text: 'Statement of Faith', action: 'statementOfFaith' },
    { text: 'Commandments of Christ', action: 'commandmentsOfChrist' },
    { text: 'Doctrines to be Rejected', action: 'doctrinesToBeRejected' },
    { text: 'Contact Us', action: 'contact' }
  ];
  const phraseMap = Object.fromEntries(phrases.map((p) => [p.text, p.action]));
  const smoothScrollTo = (targetRef) => {
    if (!targetRef) return;
  
    const checkAndScroll = () => {
      const element = targetRef.current || document.getElementById(targetRef);
      if (!element) return;
  
      requestAnimationFrame(() => {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start', 
          inline: 'nearest'
        });
      });
    };
  
    setTimeout(checkAndScroll, 800); 
  };
  const handleLinkClick = (type) => {
    if (type === 'contact') {
      navigate(PATHS.CONTACT_US);
    } else {
      const keyMap = {
        statementOfFaith: '2',
        commandmentsOfChrist: '3',
        doctrinesToBeRejected: '4'
      };
      const key = keyMap[type];
      setActiveCollapseKey([key]);
      setTimeout(() => {
        const sectionId = sectionMap[type];
        smoothScrollTo(sectionId);
      }, 800);
    }
  };

  const renderParagraph = (paragraph) => {
    const regex = new RegExp(`(${phrases.map((p) => p.text).join('|')})`, 'g');
  
    if (typeof paragraph === 'object' && paragraph.heading && paragraph.text) {
      const parts = paragraph.text.split(regex);
      return (
        <div className="mb-6">
          <h3 className="manrope-16-bold">{paragraph.heading}</h3>
          <p className="manrope-16-regular text-black-4 line-height-24 text-justify">
            {parts.map((part, index) =>
              phraseMap[part] ? (
                <span
                  key={index}
                  onClick={() => handleLinkClick(phraseMap[part])}
                  className="link-blue-4 cursor-pointer"
                >
                  {part}
                </span>
              ) : (
                <span key={index}>{part}</span>
              )
            )}
          </p>
        </div>
      );
    }
  
    // If the paragraph is a plain string
    if (typeof paragraph === 'string') {
      const parts = paragraph.split(regex);
      return (
        <p className="manrope-16-regular mb-6 text-black-4 line-height-24 text-justify">
          {parts.map((part, index) =>
            phraseMap[part] ? (
              <span
                key={index}
                onClick={() => handleLinkClick(phraseMap[part])}
                className="link-blue-4 cursor-pointer"
              >
                {part}
              </span>
            ) : (
              <span key={index}>{part}</span>
            )
          )}
        </p>
      );
    }
    console.warn('Unexpected paragraph format:', paragraph);
    return null;
  };
  const handleCollapseChange = (key) => {
    setActiveCollapseKey(key);

    if (key && key.length > 0) {
      const activeKey = key[0];
      const sectionId = sectionMap[activeKey];

      setTimeout(() => {
        smoothScrollTo(sectionId);
      }, 800);
    }
  };

  const whatWeBelieveItems = beliefItemsData.map((item) => ({
    key: item.key,
    label: (
      <p id={`${item.id}-title`} className='manrope-20-bold text-black-4 m-0'>
        {item.heading}
      </p>
    ),
    children: (
      <div>
        {item.isFaithOfAmendment ? (
          <p className='manrope-16-regular mt-0 mb-6 text-justify'>
            {item.paragraphs.map((text, index) =>
              text.trim() ? (
                text.split('\n').map((line, lineIndex) => (
                  <React.Fragment key={`${index}-${lineIndex}`}>
                    {line}
                    <br />
                  </React.Fragment>
                ))
              ) : (
                <React.Fragment key={`blank-${index}`}>
                  <br />
                </React.Fragment>
              )
            )}
            <br />
          </p>
        ) : (
          <ol className='manrope-14-regular mb-6 pl-20 text-justify'>
            {item.paragraphs.map((text, index) => (
              <li key={index}> {renderParagraph(text)}</li>
            ))}
          </ol>
        )}
        <div className={`${item.isWhatWeBelieve ? 'd-none' : 'flex justify-start' }`}>
          <DownloadButton
            title={item.title}
            content={item.content}
            paragraphs={item.paragraphs}
            isFaithOfAmendment={item.isFaithOfAmendment}
          />
        </div>
      </div>
    )
  }));

  return (
    <div className='bookroad-believe-pg p-32 pg-layout-container'>
      <div className='bg-white believe-pg-inner radius-10'>
        <CustomFlexLayout
          carouselLayout={true}
          carouselContent={getCarousel()}
          itemsList={whatWeBelieveItems}
          flexLeftCol='w-25'
          collapseClass='custom-collapse-layout mt-18'
          leftFlexlg='35%'
          rightFlexlg='65%'
          activeCollapseKey={activeCollapseKey}
          onCollapseChange={handleCollapseChange}
        >
          <div>
            <p className='mt-0 manrope-20-bold mb-16'>{whatWeBelieve.heading}</p>
            {whatWeBelieve.introParagraphs.map((paragraph, index) => (
              <p
                key={index}
                className='manrope-14-regular mb-0 text-black-4 line-height-20 text-justify'
              >
                {renderParagraph(paragraph)}
              </p>
            ))}
          </div>
        </CustomFlexLayout>
      </div>
    </div>
  );
};

export default WhatWeBelieve;
